export interface TeamsLinked {
  Id: number;
  TeamsAadObjectId?: string;
  TeamsChannelId?: string;
}

/**
 * Whether two teams or groups belong to the same Teams team. A team and a group have no id in common - they are linked
 * only by the Teams team behind them - and the server compares that id without regard to case, so this does too.
 */
export const sameTeamsTeam = (a: TeamsLinked, b: TeamsLinked): boolean =>
  !!a?.TeamsAadObjectId && a.TeamsAadObjectId.toLowerCase() === b?.TeamsAadObjectId?.toLowerCase();

export const teamHasGroups = (team: TeamsLinked | undefined, groups: TeamsLinked[]): boolean =>
  !!team && (groups ?? []).some(group => sameTeamsTeam(group, team));

/**
 * Whether a ticket set to `teamId` and `groupId` lacks the group it needs: a team with groups must have one, even when
 * an assignee is set, while a team without groups needs none (#33693). No group is null, undefined, 0 or the -1 of a
 * "No group" choice. `groups` should hold only the groups a ticket may be put in - archived ones excluded, as the app's
 * lists already are.
 */
export const isGroupMissing = (
  teamId: number | string | null | undefined,
  groupId: number | string | null | undefined,
  teams: TeamsLinked[],
  groups: TeamsLinked[]
): boolean => {
  if (!teamId || Number(groupId) > 0) return false;
  const team = (teams ?? []).find(t => String(t.Id) === String(teamId));
  return teamHasGroups(team, groups);
};
